export default "__VITE_ASSET__Dk7aozTH__"